import { takeLatest, put, call } from 'redux-saga/effects'

import { buyUserActions, BuyUserActionTypes } from '@buy/state/user/actions'
import { fatalErrorActions } from '@common/state/fatal-error/actions'
import authClass from '@common/utils/auth-class'
import { saveToken, appInsightsTrackEvent } from '@common/utils'
import commonServices from '@common/services'
import { getIsThirdPartyCookieDisabled } from '@buy/utils/get-is-thirdparty-cookie-disabled'
import { Token } from '@getgo/auth-client'
import { endSilentAuthFromIFrame } from '@common/utils/silent-auth'

function* getAccessToken() {
    try {
        yield put(buyUserActions.setVerifyingToken(true))
        const newAccessToken: Token | undefined = yield call(authClass.authInit)
        // if new token save it
        if (newAccessToken) {
            // TODO: WAE1-4010: Come back and see if this could be moved elsewhere
            // If third party cookies are not disabled and IsSilentAuth exists in sessionStorage, then the user just completed
            // a purchase (as opposed to just clicking Sign In) and silent auth in
            // the hidden iframe should have taken place. Which means this code
            // is actually being loaded inside the iframe so we need to trigger an
            // event in the parent frame to tell it to continue
            const isThirdPartyCookieDisabled = getIsThirdPartyCookieDisabled()
            const isInHiddenSilentAuthIFrame = !!window.sessionStorage.getItem('IsSilentAuth')
            if (!isThirdPartyCookieDisabled && isInHiddenSilentAuthIFrame) {
                endSilentAuthFromIFrame(newAccessToken)
                return
            }

            yield put(buyUserActions.setAccessToken(newAccessToken))
            yield call(saveToken, newAccessToken)
        } else {
            try {
                yield call(commonServices.clearUserSession)
            } catch (e: any) {
                appInsightsTrackEvent(e, { errormessage: e.message })
            }
        }
        yield put(buyUserActions.setIsUserLoggedIn(!!newAccessToken))
        // to check if this action ran
        yield put(buyUserActions.setVerifyShouldUserLogIn(true))
        yield put(buyUserActions.setVerifyingToken(false))
    } catch (e: any) {
        yield put(fatalErrorActions.setFatalError(true, { trackErrorMessage: 'failed to get access token' }))
        yield put(buyUserActions.setVerifyingToken(false))
        appInsightsTrackEvent(e, { errormessage: e.message })
    }
}

function* initializeGetAccessToken() {
    yield takeLatest(BuyUserActionTypes.GET_ACCESS_TOKEN, getAccessToken)
}

export default initializeGetAccessToken
